/**
 * Haley Air-Pro PDP interactions.
 * Gallery switching, variant sync, and compact accordion behavior.
 */

(function () {
  'use strict';

  const container = document.querySelector('[data-hap-product]');
  if (!container) return;

  const productJson = container.querySelector('#hap-product-json');
  if (!productJson) return;

  let variants = [];
  try {
    variants = JSON.parse(productJson.textContent);
  } catch (error) {
    return;
  }

  const mainImage = container.querySelector('[data-hap-main-image]');
  const mainSource = container.querySelector('[data-hap-main-source]');
  const galleryFrame = container.querySelector('.hap-gallery__main');
  const galleryThumbs = container.querySelectorAll('[data-hap-gallery-thumb]');
  const variantIdInputs = container.querySelectorAll('input[name="id"]');
  const priceEls = container.querySelectorAll('[data-hap-price]');
  const compareEls = container.querySelectorAll('[data-hap-compare]');
  const discountEls = container.querySelectorAll('[data-hap-discount]');
  const ctaPriceEls = container.querySelectorAll('[data-hap-cta-price]');
  const addTextEls = container.querySelectorAll('[data-hap-add-text]');
  const cartButtons = container.querySelectorAll('[data-hap-cart-button]');
  const sizeCards = container.querySelectorAll('[data-hap-size-card]');
  const sizeSelects = container.querySelectorAll('[data-hap-size-select]');
  const exclusiveAccordionGroups = container.querySelectorAll('[data-hap-exclusive-accordions]');
  const layerTabs = container.querySelectorAll('[data-hap-layer-tab]');
  const layerPanels = container.querySelectorAll('[data-hap-layer-panel]');
  const layerExplorer = container.querySelector('[data-hap-layer-explorer]');
  const optionCount = variants.reduce((count, variant) => {
    const optionArrayCount = (variant.options || []).length;
    const optionFieldCount = [variant.option1, variant.option2, variant.option3].filter(Boolean).length;
    return Math.max(count, optionArrayCount, optionFieldCount);
  }, 0);

  function formatMoney(cents, withSymbol) {
    const formatted = (cents / 100).toLocaleString('en-HK', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });

    return withSymbol === false ? formatted : 'HK$' + formatted;
  }

  function setUrlVariant(variant) {
    if (!variant || !window.history || !window.history.replaceState) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  function selectedOptions() {
    const options = [];

    for (let index = 0; index < optionCount; index += 1) {
      const checked = container.querySelector(`input[data-option-index="${index}"]:checked`);
      if (checked) {
        options[index] = checked.value;
      }
    }

    return options;
  }

  function findVariantByOptions(options) {
    return variants.find((variant) => {
      return options.every((option, index) => {
        const optionKey = 'option' + (index + 1);
        return variant[optionKey] === option;
      });
    });
  }

  function updateVariant(variant) {
    if (!variant) return;

    variantIdInputs.forEach((input) => {
      input.value = variant.id;
    });

    priceEls.forEach((el) => {
      el.textContent = formatMoney(variant.price, true);
    });

    // Nightly cost line under the price (snippets/haley-per-night.liquid)
    container.querySelectorAll('[data-haley-per-night]').forEach((el) => {
      const amount = el.querySelector('[data-per-night-amount]');
      const nights = Number(el.dataset.nights) || 0;
      if (amount && nights > 0) amount.textContent = 'HK$' + (Math.floor(variant.price / nights) / 100).toFixed(2);
    });

    ctaPriceEls.forEach((el) => {
      el.textContent = variant.available ? formatMoney(variant.price, true) : '';
    });

    const hasCompare = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);
    compareEls.forEach((el) => {
      el.hidden = !hasCompare;
      if (hasCompare) el.textContent = formatMoney(variant.compare_at_price, true);
    });

    discountEls.forEach((el) => {
      el.hidden = !hasCompare;
      if (!hasCompare) return;

      const percent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      el.textContent = '-' + percent + '%';
    });

    cartButtons.forEach((button) => {
      button.disabled = !variant.available;
    });

    addTextEls.forEach((el) => {
      const availableText = el.dataset.textAvailable || 'Add to cart';
      const unavailableText = el.dataset.textUnavailable || 'Sold out';
      el.textContent = variant.available ? availableText : unavailableText;
    });

    sizeCards.forEach((card) => {
      const isActive = String(card.dataset.variantId) === String(variant.id);
      card.classList.toggle('is-active', isActive);

      const input = card.querySelector('input');
      if (input) input.checked = isActive;
    });

    sizeSelects.forEach((select) => {
      select.value = String(variant.id);
    });

    for (let index = 0; index < optionCount; index += 1) {
      const optionKey = 'option' + (index + 1);
      container.querySelectorAll(`input[data-option-index="${index}"]`).forEach((input) => {
        const isMatch = variant[optionKey] === input.value;
        if (!input.closest('[data-hap-size-card]')) input.checked = isMatch;
      });
    }

    setUrlVariant(variant);
    container.dispatchEvent(new CustomEvent('haley:variant-change', { bubbles: true, detail: variant }));
  }

  galleryThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;

      const image = thumb.dataset.galleryImage;
      const mobileImage = thumb.dataset.galleryMobileImage || image;
      const alt = thumb.dataset.galleryAlt || '';
      const fit = thumb.dataset.galleryFit || 'cover';
      const isHeroImage = thumb.dataset.galleryHero === 'true';

      if (image) mainImage.src = image;
      if (mainSource && mobileImage) mainSource.srcset = mobileImage;
      mainImage.alt = alt;
      mainImage.classList.toggle('hap-gallery__image--contain', fit === 'contain');
      if (galleryFrame) galleryFrame.classList.toggle('is-hero-image', isHeroImage);

      galleryThumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  sizeCards.forEach((card) => {
    card.addEventListener('click', () => {
      if (card.dataset.available === 'false') return;

      const variant = variants.find((item) => String(item.id) === String(card.dataset.variantId));
      if (variant) updateVariant(variant);
    });
  });

  container.querySelectorAll('input[data-option-index]').forEach((input) => {
    input.addEventListener('change', () => {
      const variant = findVariantByOptions(selectedOptions());
      if (variant) updateVariant(variant);
    });
  });

  sizeSelects.forEach((select) => {
    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === String(select.value));
      if (variant) updateVariant(variant);
    });
  });

  exclusiveAccordionGroups.forEach((group) => {
    group.addEventListener('toggle', (event) => {
      const toggled = event.target;
      if (!(toggled instanceof HTMLDetailsElement) || !toggled.open) return;

      group.querySelectorAll('details').forEach((details) => {
        if (details !== toggled) details.open = false;
      });
    }, true);
  });

  layerTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const layer = tab.dataset.layer;
      if (!layer) return;

      if (layerExplorer) layerExplorer.dataset.layerActive = layer;

      layerTabs.forEach((item) => {
        const isActive = item.dataset.layer === layer;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
      });

      layerPanels.forEach((panel) => {
        const isActive = panel.dataset.layer === layer;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });
    });
  });

  const urlVariantId = new URLSearchParams(window.location.search).get('variant');
  if (urlVariantId) {
    const variant = variants.find((item) => String(item.id) === String(urlVariantId));
    if (variant) updateVariant(variant);
  }
})();
